import { getNestedValue } from '@/utils/object.js'

/**
 * Normalizes APIV3 Geored/Service/Vehicle/Configuration items
 */
export default function normalizeVehicleConfigurationItem(raw = {}) {
  let item = {
    serverId: getNestedValue(raw, 'serverId'),
    boxNumber: getNestedValue(raw, 'boxNumber'),
    vehicleCategoryName: getNestedValue(raw, 'vehicle.category.label'),
    //Used to define vehicle marker icon (see vehicle-service.js#getVehicleIconHTML)
    vehicleClassName: getNestedValue(raw, 'vehicle.category.class', '30070'),
    vehicleSpeedAlert: getNestedValue(raw, 'vehicle.speedAlert', -1),
    vehicleStopSpeedThreshold: getNestedValue(
      raw,
      'vehicle.stopSpeedThreshold',
      0
    ),
    boxConfigId: getNestedValue(raw, 'boxConfiguration.boxType.id', -1),
    isCanConfigured:
      getNestedValue(raw, 'boxConfiguration.can', 'Z').charAt(0) !== 'A',
    isCanInformationInsideANAs: getNestedValue(
      raw,
      'boxConfiguration.can',
      'Z',
      {
        transform(value) {
          if (value.charAt(0) === 'C') {
            return true
          }
          return false
        },
      }
    ),
    boxConfigSensorAssignments: getNestedValue(
      raw,
      'boxConfiguration.sensorAssignments',
      []
    ).map((saItem) => {
      let r = {
        name: getNestedValue(saItem, 'name'),
        precision: getNestedValue(saItem, 'precision'),
        factor: getNestedValue(saItem, 'factor'),
        shift: getNestedValue(saItem, 'shift'),
        lowerDisplay: getNestedValue(saItem, 'lowerDisplay'),
        upperDisplay: getNestedValue(saItem, 'upperDisplay'),
        measureType: getNestedValue(saItem, 'measureType'),
        unitLabel: getNestedValue(saItem, 'unitLabel'),
        color: getNestedValue(saItem, 'colorCodeHexa', {
          transform(hexa) {
            return `#${hexa}`
          },
        }),
        colorCode: getNestedValue(saItem, 'colorCode'),
        sensorType: getNestedValue(saItem, 'sensor.sensorType'),
        sensorNumber: getNestedValue(saItem, 'sensor.number'),
      }
      r.isDurationTOR = r.sensorType === 'TOR' && r.measureType === 'temps'
      return r
    }),
  }
  return item
}

/*
{
    "id": 172493,
    "clientName": "Berto Provence",
    "serverId": 74,
    "boxNumber": 38,
    "vehicle": {
      "id": 18954,
      "name": "104081",
      "registrationPlate": "",
      "speedAlert": 90,
      "breakAlert": 60,
      "speedDriftGps": 0,
      "stopSpeedThreshold": 3,
      "stopDetectionDuration": 180,
      "activityStart": "1970-01-01T00:00:00+01:00",
      "activityEnd": "1970-01-01T23:59:59+01:00",
      "category": { "class": 30050, "id": 11765, "label": "LaFarge" }
    },
    "start": "2014-09-02T00:00:00+02:00",
    "end": "2014-09-02T00:00:00+02:00",
    "boxConfiguration": {
      "id": 640,
      "name": "Pdf Lafarge Tor 1",
      "description": "",
      "can": "D\u00e9di\u00e9",
      "boxType": {
        "id": 3,
        "name": "M30 L",
        "outputType": 1,
        "default": true,
        "msgToDb": false
      },
      "sensorAssignments": [
        {
          "id": 1778,
          "name": "pdf",
          "measureType": "temps",
          "precision": 0,
          "factor": 1,
          "shift": 0,
          "colorCode": 2,
          "colorCodeHP": 0,
          "work": true,
          "weighing": false,
          "lowerLimit": 0,
          "upperDisplay": 0,
          "lowerDisplay": 0,
          "upperAlarm": 0,
          "lowerAlarm": 0,
          "createdAt": "2016-05-10T17:11:37+02:00",
          "updatedAt": "2016-05-10T17:11:37+02:00",
          "sensor": { "id": 23, "sensorType": "TOR", "number": 1 },
          "categoryId": 0,
          "colorCodeHexa": "2"
        }
      ]
    }
  }
  */
